import { useQuery } from '@tanstack/react-query';

import * as ApiMeta from '@Api/Meta';
import { useRequest } from '@Contexts/Request';

import type { UseQueryResult } from '@tanstack/react-query';

function useOperatorStatus(): UseQueryResult<{
  isOperatorTest: boolean;
  isOperator: boolean;
  isOperatorPopupShow: boolean;
}> {
  const request = useRequest();

  return useQuery({
    enabled: true,
    queryKey: ['operator-status'],
    queryFn: async () => {
      return ApiMeta.fetch(request);
    },
  });
}

export default useOperatorStatus;
